import ScrollButton from '../components/scroll_button';
import InfoSection from '../components/info_section';
import Layout from '../components/layout';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { opportunitiesList } from '../constants/features';
import { operating_systems, click_apps } from '../constants/compute';
import styles from '../styles/compute.module.scss';
import { useEffect, useState } from 'react';
import Slider from '../components/slider';
import Link from 'next/link';
import StartBusiness from '../components/startBusiness';
import Image from 'next/image';

export default function Compute () {
  const router = useRouter();
  const { t } = useTranslation('common');
  const [width, setWidth] = useState(null);

  useEffect(() => {
    window.addEventListener('resize', resize);

    return () => {
      window.removeEventListener('resize', resize);
    }
  }, []);

  const resize = e => {
    setWidth(e.target.innerWidth);
  };

  return (
    <Layout title={t(`computeTitle`)} lang={router.locale} route={router.route} isHeader isFooter>
      <ScrollButton scrollStepInPx='50' delayInMs='16.66' />
        <InfoSection title='Compute' description='compute.description' documentationLink='https://help.icdc.io/compute/' lang={router.locale} />
        <section className={styles.for_whom}>
          <div className='flex col'>
            <h2>{t('compute.for_whom.title')}</h2>
            <p>{t('compute.for_whom.description')}</p>
          </div>
        <Image src='/services/compute/compute.webp' alt="Compute" width={857} height={426} unoptimized loading='lazy' />
        </section>

        <section className={styles.sliders}>
        <h3>{t('compute.provide.os')}</h3>
          <Slider innerWidth={width} items={operating_systems} className='oses' />
        <h3>{t('compute.provide.apps')}</h3>
          <Slider innerWidth={width} items={click_apps} className='apps' />
        </section>

        <section className={'flex col ' + styles.features}>
          <h2>{t('compute.opportunities.title')}</h2>
          <div className={styles.features__list}>
            { opportunitiesList.map((opportunity, key) => (
              <div key={key}>
                <h3>{t(`compute.opportunities.${opportunity}.title`)}</h3>
                <p>{t(`compute.opportunities.${opportunity}.description`)}</p>
              </div>
            ))}
          </div>
        </section>

      <section className={styles.veeamIntegration}>
        <div className={styles.veeamIntegration__content}>
          <div className={styles.veeamIntegration__content__items}>
            <h2>{t('compute.veeam.title')}</h2>
            <p>{t('compute.veeam.description')}</p>
            <Link href='/veeam'>
              <a>
                <button className='btn cloud'>{t('learn_more')}</button>
                <span className='sr-only'>{t('learn_more_about_veeam')}</span>
              </a>
            </Link>
          </div>
          <Image src='/services/compute/veeamLogo.webp' alt='Veeam Logo' width={420} height={236} unoptimized loading='lazy' />
        </div>

      </section>

      <StartBusiness />

    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, ['common']),
  },
});
